import { render } from "./MigracionRadicador.vue?vue&type=template&id=6d4f8cb8"
import script from "./MigracionRadicador.vue?vue&type=script&lang=js"
export * from "./MigracionRadicador.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__